export const siteConfig = {
  name: "TNV Team Sports",
  url: "https://tnvteam.com.br/",
  description:
    "inscrição para eventos esportivo, cronometragem de corrida de rua, cronometragem eletrônica, cronometragem com Chip, cronometragem MTB, cronometragem Mountain Bike",
  links: {
    facebook: "https://www.facebook.com/tnvteam",
    instagram: "https://www.instagram.com/trinaveia/",
    youtube: "https://www.youtube.com/@tnvteam6983",
  },
  desenvolvedor: "Lesoftware",
  siteDesenvolvedor: "https://www.lesoftware.com.br",
};

export type SiteConfig = typeof siteConfig;
